import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { useOidc } from "@bnsf/oidc-token-lib-react/lib";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { authUser } = useOidc();
  const hadPriorSession = useRef(sessionStorage.getItem("withOIDC") === "true");
  const [isReady, setIsReady] = useState(() => !hadPriorSession.current);

  useEffect(() => {
    if (authUser) {
      setIsReady(true);
      sessionStorage.setItem("withOIDC", "true");
      sessionStorage.setItem("app:user", JSON.stringify(authUser));
    }
  }, [authUser]);

  useEffect(() => {
    if (isReady) return;
    const timer = setTimeout(() => {
      sessionStorage.removeItem("withOIDC");
      setIsReady(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, [isReady]);

  if (!isReady) return null;

  return (
    <AuthContext.Provider value={authUser}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
